export default {
	'en': [
		{
			title: "Download",
			description: "Welcome to Dvision World, the second New World."
		}
	]
}
